// extracted by mini-css-extract-plugin
export var aircallIframe = "_m3-3";
export var fabContainer = "_m3-5";
export var fabRinging = "_m3-6";
export var loadingOverlay = "_m3-4";
export var pulse = "_m3-7";
export var widgetContent = "_m3-2";
export var widgetPanel = "_m3-0";
export var widgetPanelExpanded = "_m3-1";